import { render, staticRenderFns } from "./PasswordFind.vue?vue&type=template&id=63fc6892&scoped=true"
import script from "./PasswordFind.vue?vue&type=script&lang=js"
export * from "./PasswordFind.vue?vue&type=script&lang=js"
import style0 from "./PasswordFind.vue?vue&type=style&index=0&id=63fc6892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc6892",
  null
  
)

export default component.exports